import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { PaginationResponse } from "../../types/Pagination";
import {
  VehicleDealer,
  VehicleDealerListFilters,
} from "../../types/VehicleDealer";

export type { VehicleDealerListFilters } from "../../types/VehicleDealer";

export const getVehicleDealers = (
  filters: VehicleDealerListFilters,
  options: APQueryOptions = {}
) => {
  const { nextPageLink, pageSize, make, state, rating, nameSearch } = filters;
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["vehicleDealers", filters],
    queryFn: async (): Promise<PaginationResponse<VehicleDealer>> => {
      const data = await fetchWithAuth<PaginationResponse<VehicleDealer>>(
        "getVehicleDealers",
        undefined,
        {
          queryParams: {
            make,
            state: state ?? undefined,
            rating: rating ?? undefined,
            nameSearch: nameSearch ?? undefined,
            nextPage: nextPageLink ?? undefined,
            pageSize: pageSize ? `${pageSize}` : undefined,
          },
        }
      );
      return {
        ...data,
        nextPageLink: data.nextPageLink ?? "",
      };
    },
    enabled: isQueryEnabled(options) && !!make,
    keepPreviousData: options.keepPreviousData,
  });
};
